<template>
    <div class="report" v-if="loaded">
        <h1>Profit &amp; Loss Report</h1>
        <div class="report-options">
            <div class="row">
                <div class="col-md-3">
                    <label>From Date</label>
                    <datepicker v-model="fromDate" id="fromDate" name="fromDate" :input-class="['form-control']" :use-utc="true"></datepicker>
                </div>
                <div class="col-md-3">
                    <label>To Date</label>
                    <datepicker v-model="toDate" id="fromDate" name="fromDate" :input-class="['form-control']" :use-utc="true"></datepicker>
                </div>
                <div class="col-md-4">
                    <label>Compare</label>
                    <select>
                        <option>Off</option>
                        <option>Month on Month</option>
                        <option>Year on Year</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label>&nbsp;</label>
                    <button class="btn orcaBtn sm-btn" @click="reloadReportData()">Refresh</button>
                </div>
            </div>
        </div>

        <div class="report-visualisation" style="max-width: 100%;">
            <apexchart height="600" type="line" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue';

Vue.use(VueApexCharts)

export default {
    name: "Profit_and_loss",
    components: {
        apexchart: VueApexCharts,
        datepicker: Datepicker,
    },
    data() {
        return {
            loaded: false,

            options: null,
            series: null,

            fromDate: null,
            toDate: null,

            // Flags
            isPayroll: false,
            isRecruitment: false,
            isPayrollEnabled: false,
            isRecruitmentEnabled: false
        }
    },
    created() {
        this.fromDate = new Date();
        this.toDate = new Date();

        this.setFlags();
        this.reloadReportData();
    },
    methods: {
        setFlags() {
            this.isPayroll = (this.crmType === 'payroll')
            this.isRecruitment = (this.crmType === 'recruitment');
            this.isPayrollEnabled = (this.isPayroll || this.isRecruitment && !this.$store.state.auth.me.recruitment);
            this.isRecruitmentEnabled = (this.isRecruitment && this.$store.state.auth.me.recruitment)
        },
        reloadReportData() {

            let self = this;

            axios.get(this.crmApiPath + 'reports/profit-and-loss/').then(r => {

                let data = r.data;
                let xAxis = [];

                // TODO: Remove temp

                data = JSON.parse('[\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-01-01",\n' +
                    '        "Amount": ".00",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-02-01",\n' +
                    '        "Amount": ".00",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-03-01",\n' +
                    '        "Amount": ".00",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-04-01",\n' +
                    '        "Amount": "666913.65",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-05-01",\n' +
                    '        "Amount": "640739.10",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-06-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-07-01",\n' +
                    '        "Amount": "655780.97",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-08-01",\n' +
                    '        "Amount": "703850.98",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-09-01",\n' +
                    '        "Amount": "863923.92",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-10-01",\n' +
                    '        "Amount": "761149.18",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-11-01",\n' +
                    '        "Amount": "1127842.30",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "CIS Tax Liability",\n' +
                    '        "Date": "2021-12-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-01-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-02-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-03-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-04-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-05-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-06-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-07-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-08-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-09-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-10-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-11-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "Corporation Tax",\n' +
                    '        "Date": "2021-12-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-01-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-02-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-03-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-04-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-05-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-06-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-07-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-08-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-09-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-10-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-11-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "S455 Taxation",\n' +
                    '        "Date": "2021-12-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-01-01",\n' +
                    '        "Amount": "848154.62",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-02-01",\n' +
                    '        "Amount": "160321.00",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-03-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-04-01",\n' +
                    '        "Amount": "1048396.88",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-05-01",\n' +
                    '        "Amount": "300865.14",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-06-01",\n' +
                    '        "Amount": "135219.14",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-07-01",\n' +
                    '        "Amount": "888147.11",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-08-01",\n' +
                    '        "Amount": "135219.14",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-09-01",\n' +
                    '        "Amount": "135219.14",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-10-01",\n' +
                    '        "Amount": "1560979.75",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-11-01",\n' +
                    '        "Amount": "135219.14",\n' +
                    '        "Compare": "0"\n' +
                    '    },\n' +
                    '    {\n' +
                    '        "NominalGroup": "VAT Liability",\n' +
                    '        "Date": "2021-12-01",\n' +
                    '        "Amount": null,\n' +
                    '        "Compare": "0"\n' +
                    '    }\n' +
                    ']');

                // Create Various Lines
                let lines = {};
                data.forEach(d => {
                    lines[d.NominalGroup] = [];
                });

                // Add data to each line
                data.forEach(d => {
                    lines[d.NominalGroup].push(d);
                });

                self.series = [];

                for (let key in lines) {
                    let amounts = []; // TODO extract amounts

                    lines[key].forEach(l => {
                        amounts.push(l.Amount || 0);
                    });

                    self.series.push(
                        {
                            name: key,
                            data: amounts
                        }
                    );
                }

                for (let key in lines) {
                    xAxis = [];
                    lines[key].forEach(l => {
                        xAxis.push(Intl.DateTimeFormat('en-GB', { dateStyle: 'short' }).format(new Date(l.Date)));
                    });
                }

                //
                // let s455 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                // let cis = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
                // let vat = [10, 5, 12, 4, 15, 17, 18, 19, 20, 21 ];
                // let tax = [23, 23, 32, 5, 6, 35, 42, 12, 53, 60 ];
                //
                // // TODO Build up the series JSON from the raw data
                //
                // self.series = [
                //     {
                //         name: 'S455 Taxation',
                //         data: s455
                //     },
                //     {
                //         name: 'CIS Tax Liability',
                //         data: cis
                //     },
                //     {
                //         name: 'VAT Liability',
                //         data: vat
                //     },
                //     {
                //         name: 'Corporation Tax',
                //         data: tax
                //     }
                // ];

                self.options = {
                    chart: {
                        height: 600,
                        type: 'line',
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#390d58', '#b51253', '#61b512', '#b56412'],
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                let currency = (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }));

                                return currency.format(value);
                            }
                        },
                    },
                    xaxis: {
                        type: 'month',
                        categories: xAxis
                    },
                };

                self.loaded = true;

            });
        },
    }
}
</script>
